"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function createSubscriptions() {
    var listeners = [];
    function subscribe(fn) {
        var isSubscribed = true;
        listeners.push(fn);
        return function () {
            if (isSubscribed) {
                unsubscribe(fn);
                isSubscribed = false;
            }
        };
    }
    function unsubscribe(fn) {
        listeners = listeners.filter(function (_fn) { return _fn !== fn; });
    }
    function unsubscribeAll() {
        listeners = [];
    }
    function publish() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        listeners.forEach(function (fn) {
            fn.apply(void 0, args);
        });
    }
    return {
        subscribe: subscribe,
        unsubscribe: unsubscribe,
        unsubscribeAll: unsubscribeAll,
        publish: publish,
    };
}
exports.default = createSubscriptions;
//# sourceMappingURL=createSubscriptions.js.map